import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts"
import { format_thousands, round_with_spaces } from "../../../utils/functions"
import stats_font_sizes from "../../../configs/stats_font_sizes.json"
import theme_colors from "../../../configs/theme_colors.json"

export default function LineChartMalaria({ stats }) {
  const { malaria } = stats

  const data = malaria

  const line_color_1 = theme_colors.sa_brown
  const line_color_2 = theme_colors.sa_brown_2
  const line_color_3 = theme_colors.sa_orange

  function CustomTooltipMalaria({ payload, label, active }) {
    if (active) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            fontSize: stats_font_sizes.tooltip_font_size,
            padding: 4,
            border: "black",
            boxShadow: "4px 6px 3px rgba(0, 0, 0, 0.2)",
          }}
        >
          <p style={{ padding: 0, margin: 0, fontWeight: "bold" }}>{label}</p>
          <p
            style={{ padding: 0, margin: 0 }}
          >{`Death cases: ${round_with_spaces(payload[0].value)}`}</p>
          <p
            style={{ padding: 0, margin: 0 }}
          >{`Reported cases: ${round_with_spaces(payload[1].value)}`}</p>
          <p
            style={{ padding: 0, margin: 0 }}
          >{`Inpatient cases: ${round_with_spaces(payload[2].value)}`}</p>
        </div>
      )
    }

    return null
  }

  const CustomLegendMalaria = () => {
    return (
      <div style={{ fontSize: 13 }}>
        <span style={{ color: line_color_1, paddingLeft: 10 }}>■</span> Deaths
        <span style={{ color: line_color_2, paddingLeft: 10 }}>■</span> Reported
        <span style={{ color: line_color_3, paddingLeft: 10 }}>■</span>{" "}
        Inpatient
      </div>
    )
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          fontSize={stats_font_sizes.x_axis_label_font_size}
        />
        <YAxis
          fontSize={stats_font_sizes.y_axis_label_font_size}
          tickFormatter={(tick) => format_thousands(tick)}
          label={{
            value: "Population",
            style: { textAnchor: "middle" },
            angle: -90,
            position: "left",
            offset: -15,
          }}
        />
        <Tooltip content={CustomTooltipMalaria} />
        <Legend content={CustomLegendMalaria} />
        <Line type="monotone" dataKey="mal_tot_death" stroke={line_color_1} />
        <Line type="monotone" dataKey="mal_tot_rep" stroke={line_color_2} />
        <Line type="monotone" dataKey="mal_inp" stroke={line_color_3} />
      </LineChart>
    </ResponsiveContainer>
  )
}
